<template>
    <div>
      <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
          <i
            class="material-icons"
            id="menu-toggle"
            @click="isSidebar = !isSidebar"
            style="cursor:pointer"
            >view_headline</i
          >
          <app-navbar></app-navbar>
          <div class="container-fluid mt-5">
            <div class="row">
              <div class="col-sm-12">
                <vs-breadcrumb
                  align="left"
                  :items="
                    [
                      {title: 'You are here : '},
                      {
                        title: 'Reports',
                        
                      },
                      {
                        title: 'Strategic Report',
                        
                        active: true
                      }
                    ]"
                ></vs-breadcrumb>
              </div>
            </div>
            <StrategicReport />
  
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from "./Navbar";
  import Sidebar from "./Sidebar";
  import StrategicReport from "../../commonPages/StrategicReport";
  
  export default {
    data: () => ({
      isSidebar: false,
      colorx: "warning"
    }),
    components: {
      "app-navbar": Navbar,
      "app-sidebar": Sidebar,
      StrategicReport
    },
    created() {},
   
  };
  </script>
  
  <style scoped>
  
  </style>
  